import React from 'react';
import { useTranslation } from 'react-i18next';
import type { FullIssueWithChildren } from '@/shared/utils/issue-guards';
import { IssueStatus } from '@momentum/types';

interface TasksTableFooterProps {
  tasks: FullIssueWithChildren[];
}

export const TasksTableFooter: React.FC<TasksTableFooterProps> = ({
  tasks,
}) => {
  const { t } = useTranslation('goals');

  const completedCount = tasks.filter(
    (t) => t.status === IssueStatus.COMPLETED
  ).length;
  const inProgressCount = tasks.filter(
    (t) => t.status === IssueStatus.IN_PROGRESS
  ).length;
  const percentComplete = Math.round((completedCount / tasks.length) * 100);

  return (
    <div className="bg-gray-50 border-t border-gray-200 px-4 py-2">
      <div className="flex items-center justify-between text-xs text-gray-600">
        <div className="flex items-center gap-4">
          <span className="font-medium">
            {t('tasksTable.taskCount')(tasks.length)}
          </span>
          <span className="text-gray-400">•</span>
          <span>
            {completedCount} {t('tasksTable.completed')}
          </span>
          <span className="text-gray-400">•</span>
          <span>
            {inProgressCount} {t('tasksTable.inProgress')}
          </span>
        </div>
        <div className="text-gray-500">
          {t('tasksTable.percentComplete')(percentComplete)}
        </div>
      </div>
    </div>
  );
};
